/* eslint-disable react/prop-types */
import cn from 'clsx';
import React from 'react';
import { ACCOUNT_MODULE_PERMISSION } from 'views/AccountManagement/components/UserForm/constants';
import ATag from './index';
import classes from './Tag.module.scss';

const colorsMapping = {
  [ACCOUNT_MODULE_PERMISSION.EDIT]: 'green',
  [ACCOUNT_MODULE_PERMISSION.ACCESS]: 'green',
  [ACCOUNT_MODULE_PERMISSION.VIEW]: 'blue',
  [ACCOUNT_MODULE_PERMISSION.NONE]: 'gray',
};
const textsMapping = {
  [ACCOUNT_MODULE_PERMISSION.EDIT]: 'Edit',
  [ACCOUNT_MODULE_PERMISSION.ACCESS]: 'Access',
  [ACCOUNT_MODULE_PERMISSION.VIEW]: 'View Only',
  [ACCOUNT_MODULE_PERMISSION.NONE]: 'No Access',
};

const AAccessTag = ({ className = '', text, ...other }) => {
  return (
    <ATag
      {...other}
      color={colorsMapping[text]}
      className={cn(classes.accessTag, classes[colorsMapping[text]], className)}>
      {textsMapping[text]}
    </ATag>
  );
};

export default AAccessTag;
